/*
 * Title: Settings/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Settings > click on Edit Display Name slide right to edit your name, click on Delete Account to delete your account.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React from "react";
import close from "@assets/close.png";
import left from "@assets/left.png";
import poweredlogo from "@assets/poweredlogo.png";
import Buttonlink from "@components/Button";
import SettingForm from "@components/SettingForm";
import { connect } from "react-redux";
import { getAppName } from "@helpers/common";
import { NavLink } from "react-router-dom";
import CallbackService from "@services/callback-service";
import { useForm } from 'react-hook-form';
import ProgramBox from "@components/ProgramBox";

interface Props {
  navigate: any;
}
type MyState = {
  setting: boolean;
  editName: boolean;
  deleteAccount: boolean;
  value: string;
  name_pass: boolean;
  name_error: boolean;
  error_message: String;
  extraInfo:Object;
  flag:boolean
};

class Settings extends React.Component<Props | any, MyState> {
  state: MyState = {
    setting: true,
    editName: false,
    deleteAccount: false,
    name_pass: false,
    name_error: false,
    value: this.props.name,
    extraInfo:(this.props.extraInfo || {}),
    error_message: "",
    flag:false
  };

  componentDidUpdate() {
    //clear success message
    if (this.props.success.success) {
      const timer = setTimeout(() => {
        this.props.authSuccess({});
      }, 2000);
      return () => clearTimeout(timer);
    }
   
  }
  settingHandle = () => {
    this.setState({ setting: false });
    this.setState({ deleteAccount: false });
    this.setState({ editName: true });
  };
  backHandle = () => {
    this.setState({ setting: true });
    this.setState({ editName: false });
    this.setState({ deleteAccount: false });
  };
  deleteAccountHandle = () => {
    this.setState({ deleteAccount: true });
    this.setState({ setting: false });
    this.setState({ editName: false });
  };
  _onChangeText = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ value: e.target.value });
  };

  _onChangeDynamic = (key, value) => {
    let extraInfo = this.state.extraInfo;
    extraInfo = {
      ...extraInfo,
      [key]:value
    }

    this.setState({ extraInfo: extraInfo});
  }



  openChannelContext = () => {
    window.location.href = `mailto:${process.env.REACT_APP_CONTACT_US_MAIL}`;
  }

  render() {
    const cname = this.props.creator.creator?.username;
    const pname = this.props.creator.program?.name;
    return (
      <div
        className={`container relative h-full mx-auto overflow-x-hidden`}
        style={{ height: "calc(100vh - 90px)" }}>
          
        {/*setting screen section*/}
        <div
          className={`${
            this.state.setting ? "left-0" : "-left-full"
          } absolute w-full transition-all duration-500 h-full text-center flex flex-col`}>
          <div className="flex flex-col h-screen">
            {/* my Settings header title & mobile menu start  */}
            <div className="px-5 pt-5">
              <div className="flex items-center justify-between">
                <h4 className="font-medium tile-inlay-primary text-[24px] tracking-wider" data-testid="setting-text">
                  Settings
                </h4>

                {getAppName() === "creator" ? (
                  <NavLink
                    to="/touchpoints"
                    state="0"
                    className="text-xl font-semibold tracking-wider text-center text-white cursor-pointer gap-x-2">
                    <img
                      src={close}
                      alt="Close"
                      className="object-contain w-4 h-4"
                    />
                  </NavLink>
                ) : (
                  <NavLink
                    to={`/${cname}/${pname}/earn`}
                    state="0"
                    className="text-xl font-semibold tracking-wider text-center text-white cursor-pointer gap-x-2">
                    
                    <svg className="h-7 w-7 tile-inlay-primary"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round">  <line x1="18" y1="6" x2="6" y2="18" />  <line x1="6" y1="6" x2="18" y2="18" /></svg>

                  </NavLink>
                )}
              </div>
            </div>
            {/* my Settings header title & mobile menu start  */}

            {/* Settings content start  */}
            <div className="px-5 mt-8 md:max-w-[420px] w-full">
              
               {/* <NavLink
                to={`/${cname}/${pname}/settings/edit/display-name`}
                className="cursor-pointer text-primary hover:text-[#fff]/100 hover:bg-[#fff]/5 py-4 block text-[18px] font-light tracking-wider w-full text-left"
              >
                Edit Display Name
              </NavLink> */}
              {Object.keys(this.props.dynamicForm || {}).length>0 &&
              <NavLink
                to={`/${cname}/${pname}/settings/edit/fan-info`}
                className="cursor-pointer tile-inlay-primary hover:text-[#fff]/100 hover:bg-[#fff]/5 py-4 block text-[18px] font-light tracking-wider w-full text-left"
              >
                Edit Fan Info
              </NavLink>
              }
              <div className="h-[1px] w-full bg-[#fff]/20" />
             {/* <Buttonlink
                className="cursor-pointer text-[#fff]/80 hover:text-[#fff]/100 hover:bg-[#fff]/5 py-4 text-[18px] font-light tracking-wider w-full text-left"
                text="Get SMS Notifications"
              />
              <div className="h-[1px] w-full bg-[#fff]/20" />
              <Buttonlink
                className="cursor-pointer text-[#fff]/80 hover:text-[#fff]/100 hover:bg-[#fff]/5 py-4 block text-[18px] font-light tracking-wider w-full text-left"
                text="Send Feedback"
              />*/}
              {/*<div className="h-[1px] w-full bg-[#fff]/20" />*/}
              <Buttonlink
                onClick={this.openChannelContext}
                className="cursor-pointer tile-inlay-primary hover:text-[#fff]/100 hover:bg-[#fff]/5 py-4 block text-[18px] font-light tracking-wider w-full text-left"
                text="Contact Us"
              />
              {/*<div className="h-[1px] w-full bg-[#fff]/20" />*/}
              {/*<Buttonlink
                onClick={this.deleteAccountHandle}
                className="cursor-pointer text-red-500 opacity-80 hover:opacity-100 hover:bg-[#fff]/5 py-4 block text-[18px] font-light tracking-wider w-full text-left"
                text="Delete Account"
              />*/}
            </div>
            {/* Settings content end  */}
            <ProgramBox box="POWERED_BY"></ProgramBox>
          </div>
        </div>
        {/*setting screen section*/}

        {/*Edit Display Name section*/}
        <div
          className={`${
            this.state.editName ? "left-0" : "left-full"
          } absolute w-full transition-all duration-500 h-full flex flex-col`}>
          {/* Edit Display Name header title & mobile menu start  */}
          <div className="px-5 pt-10">
            <div className="flex items-center gap-x-4">
              <div  className="cursor-pointer" onClick={this.backHandle}>
              <svg className="h-6 w-6 tile-inlay-primary"  width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <polyline points="15 6 9 12 15 18" /></svg>
              </div>
                <h4 className="font-normal tile-inlay-primary text-[24px] tracking-wider">
                Edit Display Name
              </h4>
            </div>
          </div>
          {/* Edit Display Name form starts*/}

          <SettingForm back={this.backHandle} />
          {/* Edit Display Name form ends */}
        </div>
        {/*Edit Display Name section*/}

        {/*Delete Account section*/}
        <div
          className={`${
            this.state.deleteAccount ? "left-0" : "left-full"
          } absolute w-full transition-all duration-500 h-full flex flex-col`}>
          <div className="flex flex-col h-screen">
            {/* Delete Account header title & mobile menu start  */}
            <div className="px-5 pt-10">
              <div className="flex items-center gap-x-4">
                <img
                  alt="Go Back"
                  src={left}
                  className="object-contain w-4 h-4 cursor-pointer"
                  onClick={this.backHandle}
                />
                <h4 className="font-normal text-white text-[24px] tracking-wider">
                  Delete Account
                </h4>
              </div>
            </div>
            {/* Delete Account header title & mobile menu end  */}

            {/* Delete Account content & action button  */}
            <div className="px-5 mt-8">
              <p className="text-white font-medium text-[18px]">
                We’re sorry to see you go!
              </p>
              <p className="text-[#fff]/80 text-[18px] font-light leading-7 max-w-lg mt-4">
                Your account will be manually deleted within 2 business days. If
                you decide to delete your account, any data we’ve collected from
                you will be made anonymous. You won’t be able to recover your
                account if you change your mind.
              </p>
              <div className="mt-10">
                {/* Delete Account action */}
                <Buttonlink
                  onClick={this.backHandle}
                  className="bg-red-500 rounded-full h-10 w-[214px] font-medium text-white text-md hover:opacity-80"
                  text="delete my account"
                />
              </div>
            </div>
            {/* Delete Account content & action button  end*/}
          </div>
        </div>
        {/*deleteAccount section end*/}
      </div>
    );
  }
}

const mapStateToProps = ({ user,creator }) => {
  return {
    user: user.user.user,
    creator: creator,
    name: (user.user?.user?.firstName || "") + " " + (user.user?.user?.lastName || ""),
    extraInfo:user.user?.user,
    isFetching: user.isFetching,
    error: user.error,
    success: user.success,
    dynamicForm:creator?.program?.extraInfo
  };
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
  const { dispatch } = dispatchProps;
  const { actions } = require("@redux/UserRedux");
  return {
    ...stateProps,
    updateUser: (data) => {
      return actions.updateUser(dispatch, data);
    },
    authSuccess: (success: Object) => {
      dispatch(actions.authSuccess(success));
    },
  };
};

export default connect(mapStateToProps, undefined, mergeProps)(Settings);
